let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("894iO")).then(() => parcelRequire('f5jiF'));